import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardHeader, CardText, CardTitle, Col, Container, Row, Table } from 'react-bootstrap'
import TarjetaDispositivos from '../Componentes/TarjetaDispositivos'
import { Dispositivo } from '../Interfaces/Interfaces'
import { obtenerDispositivos } from '../Promesas/Promesas'
import { useLocation, useNavigate } from 'react-router-dom'
import Menu from '../Componentes/Menu'
import { MenuItems } from '../Componentes/MenuItems'

interface Props{
  setToolbar:(isActive:boolean)=>void;
  hamburguesa:boolean;
  isLogin: boolean;
}
const Dispositivos = (props:Props) => {
const [dispositivos, setDispositivos] = useState<Dispositivo[]>([])
const navigate = useNavigate();

const [isModify,setIsModify] = useState(false);
useEffect(()=>{
   if(!props.isLogin){
      navigate('/')
   }
},[])
useEffect(()=>{
  

  props.setToolbar(true);
    obtenerDispositivos().then((d)=>{
        setDispositivos(d);
        
    });
},[isModify])

const agregar = ()=>{
  console.log("Agregando.");
  navigate('/agregarDispositivo');
}



  return (
    <>
<Row>
    <Menu key="menu1" menu={props.hamburguesa}>
      <MenuItems/>
    </Menu>
        <Col>
        <Container style={{marginTop:'5px'}}>
        <Row>
          <Col sm={{span:'3',offset:'9'}}>
            <Button style={{width:'100%'}} onClick={agregar}>Agregar</Button>
          </Col>
        </Row>
        <Row style={{marginTop:'5px'}}>
        {dispositivos.map((d,index)=>{
           
            return (
                <Col>
                <TarjetaDispositivos key={index} dispositivo={d} setIsModify={setIsModify} isModify={isModify}/>
                </Col>
            )
        })}
        </Row>
        </Container>
        </Col>
      </Row>
    </>
  )
}

export default Dispositivos
